import { render, staticRenderFns } from "./holiday_edit.vue?vue&type=template&id=de012a64&scoped=true"
import script from "./holiday_edit.vue?vue&type=script&lang=js"
export * from "./holiday_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de012a64",
  null
  
)

export default component.exports